export default __webpack_public_path__ + "static/media/step3.5dd9046a.svg";